const strings = {
  textModal: {
    editModalTitle: 'Editar Usuário',
  },
}

export default strings
